import moment from 'moment'
// 创建共享对象（单例）
const LogColl= {
  linkOpenTime:'', //  链接打开时间
  readStartTime:'', // 条款阅读开始时间
  readEndTime:'', // 条款阅读结束时间
  checkTime:'', // 同意按钮勾选时间 
  href:'', // 当前页面路由
}
const getCurrentTime = () => {
  return moment().format('YYYY-MM-DD HH:mm:ss')
}
/**
 * 记录指定操作的时间戳 默认当前时间
 * @description
 * 用于记录用户操作行为的时间点，如链接打开、条款阅读、勾选同意等。
 * 
 * @param {string} key - 要记录的时间字段名 
 * 
 * linkOpenTime  链接打开时间  
 * 
 * readStartTime  条款阅读开始时间 
 * 
 * readEndTime    条款阅读结束时间
 * 
 * checkTime 同意按钮勾选时间 
 * 
 * @param {string} [value] - 2026-06-25 16:15:00的字符串 不传则使用当前时间
 * 
 * @example
 * // 记录阅读开始时间（使用指定时间）
 * recordTime('readStartTime', '2026-06-25 16:15:00')
 */
export const recordTime = (key, value) => {
  if (LogColl.hasOwnProperty(key)) {
    LogColl[key] = value || getCurrentTime();
    console.log(`[LogStore] ${key} 已记录:`, value)
  } else {
    console.warn(`[LogStore] 未知的 key: ${key}`)
  }
}

// 获取整个对象
export const getLogData = () => {
  return LogColl
}

// 获取单个字段
export const getLogTime = (key) => {
  return LogColl[key] || ''
}

// 重置所有时间
export const resetLogTimes = () => {
  LogColl.linkOpenTime = ''
  LogColl.readStartTime = ''
  LogColl.readEndTime = ''
  LogColl.checkTime = ''
  console.log('[LogStore] 已重置所有时间')
}

// 导出对象本身（方便直接访问）
export default LogColl


// WEBPACK FOOTER //
// ./assets/js/utils/logStore.js